module.exports = __webpack_public_path__ + "static/media/disk.1d158c87.svg";